import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineStep {
  step: number;
  title: string;
  description: string;
  icon: string;
  completed: boolean;
}

interface AdoptionTimelineProps {
  steps: TimelineStep[];
}

const AdoptionTimeline = ({ steps }: AdoptionTimelineProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-headline font-semibold text-foreground mb-6">
        Adoption Process Timeline
      </h2>
      <div className="space-y-4">
        {steps.map((step, index) => (
          <div key={step.step} className="flex gap-4">
            <div className="flex flex-col items-center">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center ${
                  step.completed
                    ? 'bg-success text-success-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {step.completed ? (
                  <Icon name="CheckIcon" size={24} variant="solid" />
                ) : (
                  <Icon name={step.icon as any} size={24} variant="outline" />
                )}
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`w-0.5 h-16 ${
                    step.completed ? 'bg-success' : 'bg-border'
                  }`}
                />
              )}
            </div>
            <div className="flex-1 pb-8">
              <h3 className="text-lg font-body font-semibold text-foreground mb-1">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground font-body">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdoptionTimeline;